// ============================================
// LoadingSkeleton — shimmer placeholder
// ============================================
import styles from './LoadingSkeleton.module.css';

function LoadingSkeleton({ width = '100%', height = '20px', borderRadius = '8px', count = 1 }) {
    return (
        <>
            {Array.from({ length: count }).map((_, i) => (
                <div
                    key={i}
                    className={styles.skeleton}
                    style={{ width, height, borderRadius }}
                />
            ))}
        </>
    );
}

export default LoadingSkeleton;